import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';

@Directive({
    selector: '[msValueSlider]',
    standalone: true,
})
export class ValueSliderDirective implements OnChanges, AfterViewInit {
    @Input('msValueSlider') value: string;

    /**
     * An optional input to stop adding 'slide-from-top' class when event changed through left navigation tree
     */
    @Input() eventId?: string;

    private current: HTMLDivElement;
    private previous: HTMLDivElement;

    private readonly _doc = inject(DOCUMENT);

    constructor(private element: ElementRef) {}

    ngAfterViewInit(): void {
        this.current = this.createElement(this.value);
        this.previous = this.createElement(this.value, true);

        this.element.nativeElement.appendChild(this.current);

        this.element.nativeElement.appendChild(this.previous);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const value = changes['value'];
        const eventId = changes['eventId'];

        if (value && !value.firstChange && value.currentValue !== value.previousValue) {
            this.current.classList.remove('slide-from-top');
            this.previous.classList.remove('slide-from-top');
            const isSameEvent = !eventId || eventId.previousValue === eventId.currentValue;
            setTimeout(() => {
                this.current.innerText = value.currentValue;
                if (isSameEvent) {
                    this.current.classList.add('slide-from-top');
                }

                this.previous.innerText = value.previousValue;
                if (isSameEvent) {
                    this.previous.classList.add('slide-from-top');
                }
            });
        }
    }

    private createElement(value: string, hide = false): HTMLDivElement {
        const element = this._doc.createElement('div');
        element.innerText = value;
        if (hide) {
            element.classList.add('value-slider--hidden');
        }

        return element;
    }
}
